import React from "react";
import Home from "../../../assets/teams/home.png";
import Away from "../../../assets/teams/away.png";
import { Tabs } from "antd";
import { TeamTab, LastMatches, Info, Votes, StatsBox } from "./scoreBox";

const { TabPane } = Tabs;

const DetailsComponent = () => {
  return (
    <>
      <div className="text-center score-box-details-header mt-5 rounded-xl">
        <div className="flex flex-col items-center">
          <img src={Home} width={70} />
          <p>Liverpool</p>
        </div>
        <div className="flex flex-col justify-center">
          <label className="block text-2xl font-bold">0 - 3</label>
          <a className="text-lg" style={{color: "#0A66C2"}}> 25</a>
        </div>
        <div className="flex flex-col items-center">
          <img src={Away} width={70} />
          <p>Liverpool</p>
        </div>
      </div>

      <Tabs defaultActiveKey="1">
        <TabPane tab="Line-Ups" key="1">
          <TeamTab />
        </TabPane>
        <TabPane tab="Last 5" key="2">
          <LastMatches />
        </TabPane>
        <TabPane tab="H-2-H" key="3">
          <LastMatches />
        </TabPane>
        <TabPane tab="Info" key="4">
          <Info />
        </TabPane>
        <TabPane tab="Stats" key="5">
          <StatsBox />
        </TabPane>
        <TabPane tab="Votes" key="6">
          <Votes />
        </TabPane>
      </Tabs>

    </>
  );
};

export default DetailsComponent;